/*
 * POST Controller - Easily POST data to an endpoint.
 *
 * Usage Instructions:
 * 1. Define the following within the scope of this controller:
 *    - `url`: The target endpoint for the POST request.
 *    - `successMessage` (optional): The message to display on a successful request.
 *    - `errorMessage` (optional): The message to display on a failed request.
 *    - `payload` (optional): Data to send with the POST request.
 *
 * 2. Attach the controller's `submit` action to a button or link that will trigger the POST request.
 *
 * Check out the patient_row partial for an example app/views/teletherapy_rooms/_patient_row.html.erb
 */

import { Controller } from '@hotwired/stimulus';
import showToast from 'lib/toast_notification';

export default class extends Controller {
  static targets = ['postButtonText', 'postingButtonText', 'postButton'];

  static values = {
    url: String,
    payload: Object,
    successMessage: String,
    errorMessage: String,
    disableWithText: { type: String, default: 'Submitting...' },
  };

  submit() {
    const url = this.urlValue;
    const payload = this.hasPayloadValue ? this.payloadValue : {};
    const successMessage = this.successMessageValue || 'Request succeeded!';
    const errorMessage = this.errorMessageValue || 'Request failed!';
    this.updatePostButton();
    const postingToasts = showToast(this.disableWithTextValue, { type: 'info', automaticallyRemoveToast: false });

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(errorMessage);
        }
        return response.json();
      })
      .then((data) => {
        postingToasts();
        showToast(successMessage);
        this.updatePostButton();
        console.log('Response data:', data);
      })
      .catch((error) => {
        showToast(errorMessage, { type: 'error', delay: 5000 });
        this.updatePostButton();
        console.error('Error:', error);
      });
  }

  updatePostButton() {
    const postButton = this.postButtonTarget;
    const postButtonText = this.postButtonTextTarget;
    const postingButtonText = this.postingButtonTextTarget;
    if (postButtonText.classList.contains('hidden')) {
      postButtonText.classList.remove('hidden');
      postButton.removeAttribute('disabled');
      postingButtonText.classList.add('hidden');
    } else {
      postButtonText.classList.add('hidden');
      postButton.setAttribute('disabled', 'disabled');
      postingButtonText.classList.remove('hidden');
    }
  }
}
